import { Skeleton, Tabs } from 'antd';

import DrawerComponent from 'components/Drawer';
import TaskDetailsTabContent from './TaskDetailsTabContent';
import TaskHistoryContent from './TaskHistoryContent';

import useMediaQuery from 'hooks/useMediaQuery';
import useNotifyError from 'hooks/useNotifyError';
import useTaskDetailQuery from 'screens/task-management/hooks/queries/useTaskDetailQuery';

interface TaskDrawerProps {
  open: boolean;
  onClose: () => void;
  taskId: string | null;
}

const TaskDrawer = ({ open, onClose, taskId }: TaskDrawerProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const {
    data: task,
    error: taskDetailError,
    isLoading: isTaskDetailLoading,
  } = useTaskDetailQuery(taskId);

  const tabs = [
    {
      label: 'Task Details',
      key: '0',
      children: (
        <TaskDetailsTabContent
          key={task?.taskId}
          task={task!}
          isLoading={isTaskDetailLoading}
        />
      ),
    },
    {
      label: 'History',
      key: '1',
      children: (
        <TaskHistoryContent
          key={task?.taskId}
          taskId={task?.taskId}
          isLoading={isTaskDetailLoading}
        />
      ),
    },
  ];

  useNotifyError({
    error: taskDetailError,
    msg: 'Something went wrong fetching task details',
  });

  return (
    <DrawerComponent
      loading={isTaskDetailLoading}
      title={
        isTaskDetailLoading ? (
          <Skeleton.Input size="small" active />
        ) : (
          task?.taskDescription
        )
      }
      placement="right"
      width={isMobile ? '100%' : 500}
      onClose={onClose}
      open={open}
      content={<Tabs key={taskId} defaultActiveKey="0" items={tabs} />}
    />
  );
};

export default TaskDrawer;
